<template>
  <div class="loading-container">
    <transition name="fade">
      <div v-if="loading" key="loading" class="loading">
        <slot name="loading"/>
      </div>
      <div v-else key="content">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['loading'],
}
</script>
